export default {"src":"/_next/static/media/audio-icon.670f62b8.svg","height":19,"width":18};